export const TIME_DELAY = 5000; // ms - Flash Sale delay
export const SCROLL_DISTANCE = '80vh';
export const IS_LOGGED_IN = false;
export const SHOW_BANNER_CONDITION = () => true;

// A scheduled sale shows immediately, with no scroll required.
export const SCHEDULED_SALE_TIME_DELAY = 0;
export const SCHEDULED_SALE_SHOW_ON_SCROLL = false;

// Banner text constants
export const COUPON_CODE = 'PE6X5QM';
export const DEAL_TEXT = 'FLASH DEAL';
export const PERCENTAGE = '20%';
export const DISCOUNT_TEXT = `Save ${PERCENTAGE} on ANY plan with code ${COUPON_CODE}`;
export const BUTTON_TEXT = 'Act Now';
export const BUTTON_TEXT_BANNER = 'Act Now: Flash Sale';
export const FLASH_SALE_TEXT = 'Flash Sale';

// Black Friday 2026: 40% off the first payment of any plan. The same code runs through Cyber Week,
// so this banner counts down to the end of Cyber Week, when 40% ends.
export const BLACK_FRIDAY_COUPON_CODE = 'BFCM40';
export const BLACK_FRIDAY_DEAL_TEXT = 'BLACK FRIDAY';
export const BLACK_FRIDAY_PERCENTAGE = '40%';
export const BLACK_FRIDAY_DISCOUNT_TEXT = `Our biggest sale: ${BLACK_FRIDAY_PERCENTAGE} off any plan with code ${BLACK_FRIDAY_COUPON_CODE}`;
export const BLACK_FRIDAY_BUTTON_TEXT = `Save ${BLACK_FRIDAY_PERCENTAGE}`;
export const BLACK_FRIDAY_BUTTON_TEXT_BANNER = `${BLACK_FRIDAY_BUTTON_TEXT}: Black Friday Sale`;

// Cyber Week 2026: the last five days of the Black Friday offer, with the same code.
export const CYBER_MONDAY_COUPON_CODE = BLACK_FRIDAY_COUPON_CODE;
export const CYBER_MONDAY_DEAL_TEXT = 'CYBER WEEK';
export const CYBER_MONDAY_PERCENTAGE = BLACK_FRIDAY_PERCENTAGE;
export const CYBER_MONDAY_DISCOUNT_TEXT = `Last chance at ${CYBER_MONDAY_PERCENTAGE} off any plan with code ${CYBER_MONDAY_COUPON_CODE}`;
export const CYBER_MONDAY_BUTTON_TEXT = `Save ${CYBER_MONDAY_PERCENTAGE}`;
export const CYBER_MONDAY_BUTTON_TEXT_BANNER = `${CYBER_MONDAY_BUTTON_TEXT}: Cyber Week Sale`;

// Year-end 2026: 30% off the first payment of any plan, December 5 through January 4, with the
// New Year code (Rob, 2026-11-03). The New Year sale finishes it with the same code.
export const YEAR_END_COUPON_CODE = 'NY30';
export const YEAR_END_DEAL_TEXT = 'YEAR-END';
export const YEAR_END_PERCENTAGE = '30%';
export const YEAR_END_DISCOUNT_TEXT = `${YEAR_END_PERCENTAGE} off any plan with code ${YEAR_END_COUPON_CODE} through January 4`;
export const YEAR_END_BUTTON_TEXT = `Save ${YEAR_END_PERCENTAGE}`;
export const YEAR_END_BUTTON_TEXT_BANNER = `${YEAR_END_BUTTON_TEXT}: Year-End Sale`;

// New Year 2027: the last four days of the year-end offer, with the same code.
export const NEW_YEAR_COUPON_CODE = YEAR_END_COUPON_CODE;
export const NEW_YEAR_DEAL_TEXT = 'NEW YEAR';
export const NEW_YEAR_PERCENTAGE = YEAR_END_PERCENTAGE;
export const NEW_YEAR_DISCOUNT_TEXT = `Start 2027 with ${NEW_YEAR_PERCENTAGE} off any plan with code ${NEW_YEAR_COUPON_CODE}`;
export const NEW_YEAR_BUTTON_TEXT = `Save ${NEW_YEAR_PERCENTAGE}`;
export const NEW_YEAR_BUTTON_TEXT_BANNER = `${NEW_YEAR_BUTTON_TEXT}: New Year Sale`;

// Memorial Day banner text constants
export const MEMORIAL_DAY_COUPON_CODE = 'MD30';
export const MEMORIAL_DAY_DEAL_TEXT = 'MEMORIAL DAY SALE';
export const MEMORIAL_DAY_PERCENTAGE = '30%';
export const MEMORIAL_DAY_DISCOUNT_TEXT = `Save ${MEMORIAL_DAY_PERCENTAGE} on ANY plan with code ${MEMORIAL_DAY_COUPON_CODE}`;
export const MEMORIAL_DAY_BUTTON_TEXT = 'Act Now';
export const MEMORIAL_DAY_BUTTON_TEXT_BANNER = 'Act Now: Memorial Day Sale';

// Labor Day banner text constants
export const LABOR_DAY_COUPON_CODE = 'SUMMER30';
export const LABOR_DAY_DEAL_TEXT = 'LABOR DAY SALE';
export const LABOR_DAY_PERCENTAGE = '30%';
export const LABOR_DAY_DISCOUNT_TEXT = `Save ${LABOR_DAY_PERCENTAGE} on ANY plan with code ${LABOR_DAY_COUPON_CODE}`;
export const LABOR_DAY_BUTTON_TEXT = 'Act Now';
export const LABOR_DAY_BUTTON_TEXT_BANNER = 'Act Now: Labor Day Sale';

export const TIME_LEFT = 1 * 24 * 60 * 60 + 11 * 60 * 60 + 24 * 60 + 55; // 1 day + 11 hours + 24 minutes + 55 seconds
export const TARGET_DATE = new Date('2025-11-30T07:59:00Z'); // 11:59 PM PST is 7:59 AM UTC
export const IS_USE_TARGET_DATE = false;

export const SHOW_CLOSE_ICON = false;
export const BANNER_TIMER_STORAGE_KEY = 'bannerTimeLeft';

// Sale type constants
export const BLACK_FRIDAY = 'black-friday';
export const CYBER_MONDAY = 'cyber-monday';
export const YEAR_END = 'year-end';
export const NEW_YEAR = 'new-year';
export const MEMORIAL_DAY = 'memorial-day';
export const LABOR_DAY = 'labor-day';

export interface ScheduledSale {
  type: string;
  startDate: Date;
  endDate: Date;
}

// Sales schedule configuration
// Each sale runs from its startDate up to, but not including, its endDate. Windows must not
// overlap. The countdown runs to the moment the sale's code stops: the end of its own window, or of
// the following window when that window continues the same code. When no special sale is active,
// falls back to Flash Sale (default).
export const SALES_SCHEDULE: ScheduledSale[] = [
  {
    type: BLACK_FRIDAY,
    startDate: new Date('2026-11-13T08:00:00Z'), // Fri Nov 13, 12:00 AM PST
    endDate: new Date('2026-11-30T08:00:00Z'), // through Sun Nov 29, 11:59 PM PST
  },
  {
    type: CYBER_MONDAY,
    startDate: new Date('2026-11-30T08:00:00Z'), // Mon Nov 30, 12:00 AM PST
    endDate: new Date('2026-12-05T08:00:00Z'), // through Fri Dec 4, 11:59 PM PST
  },
  {
    type: YEAR_END,
    startDate: new Date('2026-12-05T08:00:00Z'), // Sat Dec 5, 12:00 AM PST
    endDate: new Date('2027-01-01T08:00:00Z'), // through Thu Dec 31, 11:59 PM PST
  },
  {
    type: NEW_YEAR,
    startDate: new Date('2027-01-01T08:00:00Z'), // Fri Jan 1, 12:00 AM PST
    endDate: new Date('2027-01-05T08:00:00Z'), // through Mon Jan 4, 11:59 PM PST
  },
  // Ended sales, kept for reference.
  {
    type: MEMORIAL_DAY,
    startDate: new Date('2026-05-22T07:00:00Z'), // May 22, 12:00 AM PDT (Fri)
    endDate: new Date('2026-05-27T07:00:00Z'), // May 27, 12:00 AM PDT (end of Tue market day)
  },
  {
    type: LABOR_DAY,
    startDate: new Date('2026-09-01T07:00:00Z'), // Sep 1, 12:00 AM PDT
    endDate: new Date('2026-09-10T07:00:00Z'), // Sep 10, 12:00 AM PDT
  },
];

const isSaleOpen = (sale: ScheduledSale, now: Date) => now >= sale.startDate && now < sale.endDate;

// Returns the scheduled sale running at `now`, or null for the Flash Sale default
export const getActiveSale = (now = new Date()): ScheduledSale | null =>
  SALES_SCHEDULE.find((sale) => isSaleOpen(sale, now)) ?? null;

// Determines which sale is currently active based on the current date/time
// Returns 'black-friday', 'cyber-monday', 'year-end', 'new-year', 'memorial-day', 'labor-day', or
// null (for Flash Sale default)
export const getActiveSaleType = (now = new Date()): string | null =>
  getActiveSale(now)?.type ?? null;

// Sale configuration type
export interface SaleConfig {
  saleType: string | null;
  dealText: string;
  percentage: string;
  discountText: string;
  couponCode: string;
  buttonText: string;
  buttonTextBanner: string;
  targetDate: Date;
  timeDelay: number;
  showOnScroll: boolean;
}

type ScheduledSaleText = Pick<
  SaleConfig,
  'dealText' | 'percentage' | 'discountText' | 'couponCode' | 'buttonText' | 'buttonTextBanner'
>;

export const SCHEDULED_SALE_TEXT: Record<string, ScheduledSaleText> = {
  [BLACK_FRIDAY]: {
    dealText: BLACK_FRIDAY_DEAL_TEXT,
    percentage: BLACK_FRIDAY_PERCENTAGE,
    discountText: BLACK_FRIDAY_DISCOUNT_TEXT,
    couponCode: BLACK_FRIDAY_COUPON_CODE,
    buttonText: BLACK_FRIDAY_BUTTON_TEXT,
    buttonTextBanner: BLACK_FRIDAY_BUTTON_TEXT_BANNER,
  },
  [CYBER_MONDAY]: {
    dealText: CYBER_MONDAY_DEAL_TEXT,
    percentage: CYBER_MONDAY_PERCENTAGE,
    discountText: CYBER_MONDAY_DISCOUNT_TEXT,
    couponCode: CYBER_MONDAY_COUPON_CODE,
    buttonText: CYBER_MONDAY_BUTTON_TEXT,
    buttonTextBanner: CYBER_MONDAY_BUTTON_TEXT_BANNER,
  },
  [YEAR_END]: {
    dealText: YEAR_END_DEAL_TEXT,
    percentage: YEAR_END_PERCENTAGE,
    discountText: YEAR_END_DISCOUNT_TEXT,
    couponCode: YEAR_END_COUPON_CODE,
    buttonText: YEAR_END_BUTTON_TEXT,
    buttonTextBanner: YEAR_END_BUTTON_TEXT_BANNER,
  },
  [NEW_YEAR]: {
    dealText: NEW_YEAR_DEAL_TEXT,
    percentage: NEW_YEAR_PERCENTAGE,
    discountText: NEW_YEAR_DISCOUNT_TEXT,
    couponCode: NEW_YEAR_COUPON_CODE,
    buttonText: NEW_YEAR_BUTTON_TEXT,
    buttonTextBanner: NEW_YEAR_BUTTON_TEXT_BANNER,
  },
  [MEMORIAL_DAY]: {
    dealText: MEMORIAL_DAY_DEAL_TEXT,
    percentage: MEMORIAL_DAY_PERCENTAGE,
    discountText: MEMORIAL_DAY_DISCOUNT_TEXT,
    couponCode: MEMORIAL_DAY_COUPON_CODE,
    buttonText: MEMORIAL_DAY_BUTTON_TEXT,
    buttonTextBanner: MEMORIAL_DAY_BUTTON_TEXT_BANNER,
  },
  [LABOR_DAY]: {
    dealText: LABOR_DAY_DEAL_TEXT,
    percentage: LABOR_DAY_PERCENTAGE,
    discountText: LABOR_DAY_DISCOUNT_TEXT,
    couponCode: LABOR_DAY_COUPON_CODE,
    buttonText: LABOR_DAY_BUTTON_TEXT,
    buttonTextBanner: LABOR_DAY_BUTTON_TEXT_BANNER,
  },
};

// The moment a scheduled sale's code stops. Following windows that continue the same code extend
// it, so the Black Friday countdown runs to the end of Cyber Week instead of a deadline that passes
// with no change in price.
export const getSaleOfferEnd = (sale: ScheduledSale): Date => {
  const { couponCode } = SCHEDULED_SALE_TEXT[sale.type];
  let end = sale.endDate;
  for (let step = 0; step < SALES_SCHEDULE.length; step += 1) {
    const next = SALES_SCHEDULE.find(
      (later) =>
        later.startDate.getTime() === end.getTime() &&
        later.endDate > end &&
        SCHEDULED_SALE_TEXT[later.type].couponCode === couponCode,
    );
    if (!next) break;
    end = next.endDate;
  }
  return end;
};

// Centralized function to get current sale configuration
// This ensures Banner and PromoButton components always show the same sale
export const getCurrentSaleConfig = (now = new Date()): SaleConfig => {
  const sale = getActiveSale(now);

  if (sale) {
    return {
      saleType: sale.type,
      ...SCHEDULED_SALE_TEXT[sale.type],
      targetDate: getSaleOfferEnd(sale),
      timeDelay: SCHEDULED_SALE_TIME_DELAY,
      showOnScroll: SCHEDULED_SALE_SHOW_ON_SCROLL,
    };
  }

  // Default to Flash Sale
  return {
    saleType: null,
    dealText: DEAL_TEXT,
    percentage: PERCENTAGE,
    discountText: DISCOUNT_TEXT,
    couponCode: COUPON_CODE,
    buttonText: BUTTON_TEXT,
    buttonTextBanner: BUTTON_TEXT_BANNER,
    targetDate: IS_USE_TARGET_DATE ? TARGET_DATE : new Date(Date.now() + TIME_LEFT * 1000),
    timeDelay: TIME_DELAY,
    showOnScroll: true,
  };
};
